// @flow

import React from "react";
import ReactDOM from "react-dom";

import Accordion from "../components/Accordion";

const els = document.querySelectorAll(".accordion");
els.forEach((el: HTMLElement) => {
    const dataString = el.getAttribute("data-accordion") || "";
    const data = JSON.parse(dataString);
    if (data) {
        ReactDOM.render(
            <Accordion
                title={data.title}
                tag={data.tag}
                contentString={data.content}
            />,
            el
        );
    }
});
